import React, { Component } from 'react'
import ShowComponents from '../Common/ShowComponent'
import { Box, TextField, Tooltip, Stack } from '@mui/material'
import { CommonDeleteButton, DeletePopup } from '../../../../Components/Common Components/CommonComponents'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { qDoctorPatientId, qDoctorAppointmentId } from '../../../../Utility/Services/DoctorPatientQueryIds'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { withTranslation } from 'react-i18next';
import { DataGrid } from '@mui/x-data-grid';

class DocFinalDiagnosisLeft extends Component {
  constructor(props) {
    super(props)
    this.state = {
      DiagnosisData: [],
      isDeleteCliked: false,
      SelectedList: {},
      finalDiagnosisTxt: "",
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  componentDidUpdate(prevprops) {
    if (prevprops.GetAPiCall !== this.props.GetAPiCall && this.props.GetAPiCall) { this.getFinalDiagnosis() }
  }

  getFinalDiagnosis() {
    try {
      RestAPIService.getAllTwo(Serviceurls.DOC_FINAL_DIAGNOSIS_GET + `?patient_id=${qDoctorPatientId(this.props?.PatientData?.patient_id)}&appointment_id=${qDoctorAppointmentId(this.props?.PatientData?.appointment_id)}`).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              DiagnosisData: response.data.data?.icd_codes ? response.data.data?.icd_codes : [],
              finalDiagnosisTxt: response.data.data?.comments ? response.data.data?.comments : ""
            }, () => {
              this.onEditHandler()
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  onEditHandler() {
    this.props.EditFinalDiagnosisTxt(this.state.finalDiagnosisTxt)
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  DeleteAdvice() {
    try {
      let states = this.state
      let data = {
        comments: "",
        appointment_id: this.props?.PatientData?.appointment_id,
        patient_id: this.props?.PatientData?.patient_id,
        system_name: 'Final Diagnosis',
        custom_name: this.props.custom_name ? this.props.custom_name : '',
        icd_codes: [...states.DiagnosisData],
      }
      RestAPIService.create(data, Serviceurls.DOC_FINAL_DIAGNOSIS_GET)
        .then((response) => {
          if (response.data.status === "success") {
            this.successMessage(response.data.message)
            this.setState({ finalDiagnosisTxt: "" }, () => {
              this.onEditHandler()
            })
          } else {
            this.errorMessage(response.data.message)
          }
        }).catch(error => {
          if (error?.response?.data?.status === "fail") {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  onDeleteHandler(data) {
    try {
      this.setState({
        isDeleteCliked: true,
        SelectedList: data.row,
      })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  DeleteDiagnosis() {
    try {
      const states = this.state
      RestAPIService.delete(Serviceurls.DOC_FINAL_DIAGNOSIS_GET + "?id=" + states.SelectedList.id)
        .then((response) => {
          if (response.data.status === "success") {
            this.successMessage(response.data.message)
            this.setState({ isDeleteCliked: false }, () => { this.getFinalDiagnosis() })
          } else {
            this.errorMessage(response.data.message)
          }
        }).catch(error => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  popupClose() {
    this.setState({ isDeleteCliked: false })
  }

  apicalls = () => {
    this.getFinalDiagnosis();
    this.props.triggerPreviousHistory('final_diagnosis')
  }

  render() {
    const { t } = this.props
    this.state.DiagnosisData.forEach((element, index) => { element.sno = index + 1 })
    const columns = [
      {
        field: "icd_code", flex: 0.10, headerName: t("ICDcode"),
        renderCell: (params) => (<Box component={'div'}>
          {params?.row?.icd_code ? params?.row?.icd_code?.length > 18 ?
            <Tooltip placement='top' title={params?.row?.icd_code} arrow>
              <div>{params?.row?.icd_code.slice(0, 18) + "..."}</div></Tooltip> :
            params?.row?.icd_code : "-"}
        </Box>)
      },
      {
        field: "short_desc", flex: 0.25, headerName: t("ShortDescription"),
        renderCell: (params) => (<Box component={'div'}>
          {params?.row?.short_desc ? params?.row?.short_desc?.length > 40 ?
            <Tooltip placement='top' title={params?.row?.short_desc} arrow>
              <div>{params?.row?.short_desc.slice(0, 40) + "..."}</div></Tooltip> :
            params?.row?.short_desc : "-"}
        </Box>)
      },
      {
        field: "desc", flex: 0.25, headerName: t("LongDescription"),
        renderCell: (params) => (<Box component={'div'}>
          {params?.row?.desc ? params?.row?.desc?.length > 40 ?
            <Tooltip placement='top' title={params?.row?.desc} arrow>
              <div>{params?.row?.desc.slice(0, 40) + "..."}</div></Tooltip> :
            params?.row?.desc : "-"}
        </Box>)
      },
      {
        field: "action", flex: 0.10, headerName: t("Action"), headerAlign: "center", align: "center",
        renderCell: (params) => <div>
          <CommonDeleteButton size={"1.2vw"} disable={this.props?.isLocked} onClick={this.onDeleteHandler.bind(this, params)} />
        </div>
      }
    ]
    return (
      <ShowComponents onIntersection={this.apicalls.bind(this)}>
        <Box height={'20vh'} overflow={'auto'}>
          <DataGrid
            density='compact'
            rows={this.state.DiagnosisData}
            columns={columns}
            getRowId={(row) => row['sno']}
            headerHeight={40}
            hideFooter={true}
            components={{
              NoRowsOverlay: () => (
                <Stack className='eMed_DocNotes_nodata' height={'20vh'}>
                  {t("NoRecordsFound")}
                </Stack>
              )
            }}
            disableSelectionOnClick
          />

          {this.state.isErrorMsg ?
            <ToastMsg
              severity={'error'}
              msg={this.state.isErrorMsgText}
              msgPop={this.msgClose.bind(this)}
            />
            : null}
          {this.state.successMsg ?
            <ToastMsg
              severity={'success'}
              msg={this.state.successMsgText}
              msgPop={this.msgClose.bind(this)}
            />
            : null}
          {this.state.isDeleteCliked ? <DeletePopup
            DeletTitle={`${t("deleteMsg")}  ${t("Final Diagnosis")} ${this.state.SelectedList ? this.state.SelectedList?.icd_code : "-"} ?`}
            deleteAlertPopupClose={this.popupClose.bind(this)}
            removeData={this.DeleteDiagnosis.bind(this)}
          /> : null}
        </Box>
        <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} marginY={"0.5dvw"}>
          <TextField
            size='small'
            sx={{ width: '54vw', margin: '1vw' }}
            multiline={true}
            maxRows={5}
            label={`${this.props.custom_name || "Final Diagnosis"} notes`}
            value={this.state.finalDiagnosisTxt}
            InputProps={{ readOnly: true }}
          />
          <Box marginTop={'0.3vw'} sx={{ display: 'flex', flexDirection: 'column' }}>
            {/* <CommonEditButton size={"1.5vw"} disable={this.props?.isLocked || !this.state.finalDiagnosisTxt} onClick={this.onEditHandler.bind(this)} /> */}
            <CommonDeleteButton size={"1.5vw"} disable={this.props?.isLocked || !this.state.finalDiagnosisTxt} onClick={this.DeleteAdvice.bind(this, true)} />
          </Box>
        </Box>
      </ShowComponents>
    )
  }
}
export default withTranslation()(DocFinalDiagnosisLeft)